import React, { useState } from 'react';
import './ColorStraps.css';

const strapVariants = {
  Blue: {
    M: '43766786949165',
    L: '44289387298861'
  },
  Pink: {
    M: '44334003126317',
    L: '44334003159085'
  },
  Red: {
    M: '43766786916397',
    L: '44289387266093'
  },
  Yellow: {
    M: '44334003060781',
    L: '44334003093549'
  },
  White: {
    M: '43766786981933',
    L: '44289387331629'
  },
  Black: {
    M: '43766786883629',
    L: '44289387233325'
  }
};

const straps = [
  {
    name: 'Blue',
    color: '#1E90FF',
    bg: '#0a1628',
    img: '/straps/blue-strap.webp',
    variant: '44334003126317',
    strapLedTop: '25.5%',
    strapLedLeft: '72.6%',
    caseLedTop: '63.4%',
    caseLedLeft: '21.4%'
  },
  {
    name: 'Pink',
    color: '#FF0083',
    bg: '#1a0010',
    img: '/straps/pink-strap.webp',
    variant: '44334003159085',
    strapLedTop: '25.5%',
    strapLedLeft: '72.6%',
    caseLedTop: '63.4%',
    caseLedLeft: '21.4%'
  },
  {
    name: 'Red',
    color: '#E8001A',
    bg: '#1a0005',
    img: '/straps/red-strap.webp',
    variant: '44334003191853',
    strapLedTop: '25.5%',
    strapLedLeft: '72.6%',
    caseLedTop: '63.4%',
    caseLedLeft: '21.4%'
  },
  {
    name: 'Yellow',
    color: '#F5D800',
    bg: '#1a1600',
    img: '/straps/yellow-strap.webp',
    variant: '44334003224621',
    strapLedTop: '25.5%',
    strapLedLeft: '72.6%',
    caseLedTop: '63.4%',
    caseLedLeft: '21.4%'
  },
  {
    name: 'White',
    color: '#E8E8E8',
    bg: '#161618',
    img: '/straps/white-strap.webp',
    variant: '44334003257389',
    strapLedTop: '25.5%',
    strapLedLeft: '72.6%',
    caseLedTop: '63.4%',
    caseLedLeft: '21.4%'
  },
  {
    name: 'Black',
    color: '#2a2a2a',
    bg: '#0d0d0d',
    img: '/straps/black-strap.webp',
    variant: '44334003290157',
    strapLedTop: '25.5%',
    strapLedLeft: '72.6%',
    caseLedTop: '63.4%',
    caseLedLeft: '21.4%'
  },
];

export default function ColorStraps() {
  const [active, setActive] = useState(0);
  const selected = straps[active];
  const [selectedSize, setSelectedSize] = useState(null); // null = no size chosen yet
  const [sizeError, setSizeError] = useState(false);

  const handleStrapBuyClick = (e) => {
    if (!selectedSize) {
      e.preventDefault();
      setSizeError(true);
      const sizeEl = document.getElementById('strap-size-selector');
      if (sizeEl) sizeEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <section className="straps-section" id="color-straps">
      <div
        className="straps-bg-glow"
        style={{ background: `radial-gradient(ellipse 60% 50% at 50% 100%, ${selected.color}22 0%, transparent 70%)` }}
      />
      <div className="container">

        <div className="section-header text-center">
          <span className="badge-volt">ACCESSORIES</span>
          <h2 className="section-title">MATCH YOUR KIT</h2>
          <p className="section-subtitle">
            Swap your Playermaker straps to match your team colours, mood, or season. Mix and match across all 6 colours.
          </p>
        </div>

        <div className="straps-grid">

          {/* ── Image display ── */}
          <div className="straps-visual">
            <div
              className="straps-img-wrap"
              style={{ backgroundColor: selected.bg }}
            >
              <div style={{ position: 'relative', width: '90%', height: '90%' }}>
                <img
                  key={active}
                  src={selected.img}
                  alt={`Playermaker Canada ${selected.name} replacement silicone strap for soccer cleats`}
                  className="straps-img"
                  width="600"
                  height="600"
                  loading="lazy"
                  style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                  onError={(e) => {
                    // Fallback: hide broken image gracefully
                    e.target.style.opacity = '0.3';
                  }}
                />
                {/* Pulsating Blue LEDs */}
                <div className="blue-led-pulse" style={{ top: selected.caseLedTop || '62.3%', left: selected.caseLedLeft || '24.4%' }} />
                <div className="blue-led-pulse" style={{ top: selected.strapLedTop || '25.5%', left: selected.strapLedLeft || '72.3%' }} />
              </div>

              {/* Colour glow behind image */}
              <div
                className="straps-img-glow"
                style={{ background: `radial-gradient(circle at 50% 80%, ${selected.color}44 0%, transparent 65%)` }}
              />
            </div>
          </div>

          {/* ── Details + picker ── */}
          <div className="straps-details card-tech">
            <span className="badge-volt">$29.00 CAD</span>

            <h3 className="straps-title">
              Playermaker Coloured Straps
              <span className="straps-selected-colour" style={{ color: selected.color }}>
                {' '}, {selected.name}
              </span>
            </h3>

            <p className="straps-desc">
              Customize your Playermaker to match your kit. Available in 6 colours, grab all of them and switch based on your team, season, or mood.
            </p>

            {/* Colour picker swatches */}
            <div className="straps-picker-label">SELECT COLOUR</div>
            <div className="straps-swatches">
              {straps.map((s, i) => (
                <button
                  key={s.name}
                  className={`swatch-btn${active === i ? ' active' : ''}`}
                  style={{
                    '--swatch-color': s.color,
                    backgroundColor: s.color,
                    boxShadow: active === i ? `0 0 0 3px var(--bg-obsidian), 0 0 0 5px ${s.color}` : 'none',
                  }}
                  onClick={() => setActive(i)}
                  title={s.name}
                  aria-label={`Select ${s.name} strap`}
                />
              ))}
            </div>

            {/* Size Selector */}
            <div className="selector-group" id="strap-size-selector">
              <span className="selector-label" style={{ color: sizeError ? '#FF003B' : 'inherit' }}>
                SELECT STRAP SIZE {sizeError && ',  PLEASE SELECT A SIZE'}
              </span>
              <div className="size-buttons">
                <button 
                  type="button"
                  className={`size-btn ${selectedSize === 'M' ? 'active' : ''} ${sizeError ? 'size-btn-error' : ''}`}
                  onClick={() => { setSelectedSize('M'); setSizeError(false); }}
                >
                  <span className="size-title">Medium (M)</span>
                  <span className="size-desc">Cleat sizes US 5.5, US 8</span>
                </button>
                <button 
                  type="button"
                  className={`size-btn ${selectedSize === 'L' ? 'active' : ''} ${sizeError ? 'size-btn-error' : ''}`}
                  onClick={() => { setSelectedSize('L'); setSizeError(false); }}
                >
                  <span className="size-title">Large (L)</span>
                  <span className="size-desc">Cleat sizes US 8.5+</span>
                </button>
              </div>
            </div>

            <div className="straps-features">
              <div className="strap-feature">
                <span className="strap-feature-icon">⚡</span>
                <span>Fits all Playermaker 2.0 sensors</span>
              </div>
              <div className="strap-feature">
                <span className="strap-feature-icon">🌧</span>
                <span>All-weather silicone, pitch ready</span>
              </div>
              <div className="strap-feature">
                <span className="strap-feature-icon">🔄</span>
                <span>Swaps in seconds, no tools needed</span>
              </div>
            </div>

            {/* Size reminder warning box */}
            {sizeError && (
              <div className="size-reminder-box">
                <span className="size-reminder-icon">⚠️</span>
                <span>Please select a strap size (Medium or Large) to continue.</span>
              </div>
            )}

            <a
              href={selectedSize ? `https://kimeoconsulting.myshopify.com/cart/${strapVariants[selected.name][selectedSize]}:1` : '#strap-size-selector'}
              onClick={handleStrapBuyClick}
              className="btn btn-volt straps-buy-btn"
              style={{ width: '100%', textAlign: 'center', display: 'block', marginBottom: '2rem' }}
            >
              Buy {selected.name} Straps: $29.00 CAD
            </a>

            <p className="straps-shipping-note">
              Free expedited shipping on orders over $75 · Ships from Canada
            </p>
          </div>

        </div>

        {/* Thumbnail strip */}
        <div className="straps-thumb-strip">
          {straps.map((s, i) => (
            <button
              key={s.name}
              className={`straps-thumb${active === i ? ' active' : ''}`}
              onClick={() => setActive(i)}
              style={{ borderColor: active === i ? s.color : 'transparent' }}
              aria-label={`View ${s.name} strap`}
            >
              <img src={s.img} alt={`Playermaker ${s.name} replacement soccer strap`} width="300" height="200" loading="lazy" />
              <span style={{ color: active === i ? s.color : 'var(--text-muted)' }}>{s.name}</span>
            </button>
          ))}
        </div>

      </div>
    </section>
  );
}
